export const StorageKeys = {
  firstPage: 'sf_first_page',
  marketingUrl: 'sf_marketing_url',
  history: 'sf_history',
  ref: 'sf_referrer',
  refDomain: 'sf_referrng_domain',

  abData: 'sf_ab_data',
  abCid: 'sf_ab_cid',
  variantToSet17477: 'variant_to_set_17477',

  questionnairePosition: 'sf_lq_position',
  questionnaireChoices: 'sf_lq_choices',
  questionnaireBooks: 'sf_lq_books',
  offerGuide: 'sf_17817_offer_guide',

  authToken: 'auth_token',
  user: 'user',
  previouslyLogin: 'previously_logged_in',

  changelog: 'sf_changelog',
  nightMode: 'sf_night_mode',
  weglotStoredLang: 'wglang',
  position: 'sf_position',

  bannerDismissed17477: 'sf_17477_banner_dismissed',
  popupDismissed17477: 'sf_17477_popup_dismissed',

  iosConsentSetting: 'iosConsentSetting',
  playerVolume: 'sf_player_volume',
  playerRate: 'sf_player_rate',
  capacitorUid: '_capuid',
  offlineAnnotations: 'offline_annotations',
  annotator: 'sf_annotator',
  cancelDiscount: 'sf_cancel_discount',
  tutorialAutoShow: 'sf_tutorial_auto_show',
  readingSettings: 'sf_reading_settings',
  needsUpdate: 'sf_needs_update',
  onboardingQuestionStep: 'sf_oq_step',

  upgradePromptModal18151: 'sf_18151_upgrade_prompt_modal',
  pagesVisited18151: 'sf_18151_pages_visited',

  annualUpsellPromptPagesVisited18236:
    'sf_18236_annual_upsell_prompt_started_pages_visited',
  annualUpsellPromptModal18236: 'sf_18236_annual_upsell_prompt_modal',
  annualUpsellPromptBanner18236: 'sf_18236_annual_upsell_prompt_banner',

  partnerCreatorSession: 'sf_partner_creator',
  partnerDiscountBannerDismissed: 'sf_partner_discount_banner_dismissed',
  partnerDiscountPopupDismissed: 'sf_partner_discount_popup_dismissed',
} as const

export type StorageKey = (typeof StorageKeys)[keyof typeof StorageKeys]
